import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.css';

const Career = () => {
    return (
        <div className='div-padd'>
        
        <div className="hero-section">
          <Container>
            
                <br/>
                <h1 className="display-4">Careers</h1>
                
                <br/>
                <p className="lead">Brave Fox presently hiring consultants for the following requirements across locations:
                <br/>
                
                <li>
                JDA Technical and Functional Consultants
  </li>
  <li>
  Oracle Cloud Technical and Functional Consultants
  
  </li>
  <li>
  Azure Architects
  </li>
  <li>
  Azure Developers
  </li>
  <li>
  UI Developers - HTML, CSS, Java Script, Angular JS, OOJS, Bootstrap
  </li>
  <li>
  Pega Developers
  </li>
  <li>
Selenium Testers
  </li>

  <li> Microsot EPM</li>
  <li>SAP Professionals across modules and skills</li>
  <li>ATG Developers and Leads</li>
  <li>Oracle Coherence Developers</li>
<li>Dotnet and Sharepoint Developers</li>
<li>Hyperion HFM resources</li>
<li>Hyperion Developers and Amins</li>
<li>Adobe CQ Developers, Leads and Architechts</li>
<li>Java Developers and Leads</li>
<br/>
<br/>

<p>Please send your resumes to <u>careers@bravefox.org</u> with your skillset, years of exp and location in the subject line</p>
<br/>
     
                </p>
              <p/>



    
                
              
          </Container>
        </div>
        </div>
    );
}
export default Career;
